// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══ MAIN CONTENT ════════════════════════════════════════════════════════ */
.dashboard-main {
  display: flex;
  flex-direction: column;
}

.content-area {
  flex: 1;
}

/* Tab styling */
.tabs li[aria-selected="true"] {
  color: #0b2d71 !important;
  font-weight: 600;
  border: 4px solid #fff;
  border-width: 0 0 4px;
  border-bottom: #0b2d71 4px solid;
}

div.tabbed > ul.tabs {
  margin: 0;
  padding: 0;
  text-align: left;
}

.breadcrumb-link {
  color: #0b2d71;
  text-decoration: none;
}

.breadcrumb-link:hover {
  text-decoration: underline;
}

.header-info-strip {
  background-color: #f8f9fa;
}

/* ── Spacer Info styles ──────────────────────────────────── */
.materials-section {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 1rem;
  background-color: #f8f9fa;
  margin-bottom: 20px;
}

.section-title {
  color: #0b2d71;
  font-size: 1.1rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #0b2d71;
}

.table-wrapper {
  overflow-x: auto;
}

.table {
  background-color: white;
  font-size: 0.9rem;
}

.table-header {
  background-color: #e9ecef;
  font-weight: bold;
}

.table-header th {
  padding: 0.5rem;
  text-align: center;
  vertical-align: middle;
  font-size: 0.85rem;
}

.table tbody td {
  padding: 0.25rem;
  vertical-align: middle;
}

.form-control-sm {
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
}

.remove-icon {
  color: #c0392b;
  font-weight: bold;
  cursor: pointer;
  font-size: 1.2rem;
}

.remove-icon:hover {
  color: #a93226;
}

.small-icon {
  font-size: 16px;
  line-height: 16px;
  width: 16px;
  height: 16px;
}

.input-group .btn {
  padding: 0.25rem 0.5rem;
}

input[type="number"].form-control-sm,
input[type="text"].form-control-sm,
select.form-control-sm {
  min-width: 80px;
}

textarea.form-control {
  resize: vertical;
}

/* Tab content */
.tab-content {
  display: block;
}

.tab-content[aria-hidden="true"] {
  display: none;
}

/* Additive search dropdown */
.additive-inline-search {
  position: relative;
  max-width: 400px;
  margin-left: 10px;
}

.additive-search-input {
  width: 100%;
}

.additive-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin: 0;
  padding: 0;
  list-style: none;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.additive-dropdown li {
  padding: 0.5rem 0.75rem;
  cursor: pointer;
}

.additive-dropdown li:hover {
  background-color: #f8f9fa;
}
.border-danger {
  border: 2px solid #E21836 !important;
  box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/add-new-spacer-modal/create-spacer-info/create-spacer-info.component.css"],"names":[],"mappings":"AAAA,8EAA8E;AAC9E;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+DAA+D;AAC/D;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B","sourcesContent":["/* ═══ MAIN CONTENT ════════════════════════════════════════════════════════ */\n.dashboard-main {\n  display: flex;\n  flex-direction: column;\n}\n\n.content-area {\n  flex: 1;\n}\n\n/* Tab styling */\n.tabs li[aria-selected=\"true\"] {\n  color: #0b2d71 !important;\n  font-weight: 600;\n  border: 4px solid #fff;\n  border-width: 0 0 4px;\n  border-bottom: #0b2d71 4px solid;\n}\n\ndiv.tabbed > ul.tabs {\n  margin: 0;\n  padding: 0;\n  text-align: left;\n}\n\n.breadcrumb-link {\n  color: #0b2d71;\n  text-decoration: none;\n}\n\n.breadcrumb-link:hover {\n  text-decoration: underline;\n}\n\n.header-info-strip {\n  background-color: #f8f9fa;\n}\n\n/* ── Spacer Info styles ──────────────────────────────────── */\n.materials-section {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  margin-bottom: 20px;\n}\n\n.section-title {\n  color: #0b2d71;\n  font-size: 1.1rem;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #0b2d71;\n}\n\n.table-wrapper {\n  overflow-x: auto;\n}\n\n.table {\n  background-color: white;\n  font-size: 0.9rem;\n}\n\n.table-header {\n  background-color: #e9ecef;\n  font-weight: bold;\n}\n\n.table-header th {\n  padding: 0.5rem;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 0.85rem;\n}\n\n.table tbody td {\n  padding: 0.25rem;\n  vertical-align: middle;\n}\n\n.form-control-sm {\n  font-size: 0.85rem;\n  padding: 0.25rem 0.5rem;\n}\n\n.remove-icon {\n  color: #c0392b;\n  font-weight: bold;\n  cursor: pointer;\n  font-size: 1.2rem;\n}\n\n.remove-icon:hover {\n  color: #a93226;\n}\n\n.small-icon {\n  font-size: 16px;\n  line-height: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.input-group .btn {\n  padding: 0.25rem 0.5rem;\n}\n\ninput[type=\"number\"].form-control-sm,\ninput[type=\"text\"].form-control-sm,\nselect.form-control-sm {\n  min-width: 80px;\n}\n\ntextarea.form-control {\n  resize: vertical;\n}\n\n/* Tab content */\n.tab-content {\n  display: block;\n}\n\n.tab-content[aria-hidden=\"true\"] {\n  display: none;\n}\n\n/* Additive search dropdown */\n.additive-inline-search {\n  position: relative;\n  max-width: 400px;\n  margin-left: 10px;\n}\n\n.additive-search-input {\n  width: 100%;\n}\n\n.additive-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  max-height: 200px;\n  overflow-y: auto;\n  background: white;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  z-index: 1000;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.additive-dropdown li {\n  padding: 0.5rem 0.75rem;\n  cursor: pointer;\n}\n\n.additive-dropdown li:hover {\n  background-color: #f8f9fa;\n}\n.border-danger {\n  border: 2px solid #E21836 !important;\n  box-shadow: none !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
